import { supportConstants as sc } from 'srcReact/Pages/Support/constants'
const initialState = {
  contact: {
    loading: false,
    success: false,
    error: false
  },
  tickets: {
    list: [],
    stats: null,
    loading: false,
    error: ''
  },
  ticket: {
    data: null,
    loading: false,
    error: ''
  }
}

export function support(state = initialState, action) {
  switch (action.type) {
    case sc.CLEAR_DATA: {
      return {
        ...state,
        ticket: {
          ...state.ticket,
          data: null,
          loading: false,
          error: ''
        }
      }
    }
    case sc.SUBMIT_CONTACT_REQUEST:
      return {
        ...state,
        contact: {
          loading: true,
          success: false,
          error: false
        }
      }
    case sc.SUBMIT_CONTACT_SUCCESS:
      return {
        ...state,
        contact: {
          loading: false,
          success: true,
          error: false
        },
        ticket: {
          data: action.response
        }
      }

    // failures
    case sc.SUBMIT_CONTACT_FAILURE:
      return {
        ...state,
        contact: {
          loading: false,
          success: false,
          error: true
        }
      }

    case sc.GET_TICKETS_REQUEST: {
      return {
        ...state,
        tickets: {
          ...state.tickets,
          loading: true
        }
      }
    }
    case sc.GET_TICKETS_SUCCESS: {
      const { tickets, stats } = action.response
      return {
        ...state,
        tickets: {
          ...state.tickets,
          loading: false,
          list: tickets,
          stats: stats
        }
      }
    }
    case sc.GET_TICKETS_FAILURE: {
      return {
        ...state,
        tickets: {
          ...state.tickets,
          loading: false,
          error: action.error
        }
      }
    }

    case sc.GET_TICKET_BY_ID_REQUEST: {
      return {
        ...state,
        ticket: {
          ...state.ticket,
          loading: true
        }
      }
    }
    case sc.GET_TICKET_BY_ID_SUCCESS: {
      return {
        ...state,
        ticket: {
          ...state.ticket,
          loading: false,
          data: action.response
        }
      }
    }
    case sc.GET_TICKET_BY_ID_FAILURE: {
      return {
        ...state,
        ticket: {
          ...state.ticket,
          loading: false,
          error: action.error
        }
      }
    }

    case sc.UPDATE_TICKET_REQUEST: {
      return {
        ...state
      }
    }
    case sc.UPDATE_TICKET_SUCCESS: {
      return {
        ...state,
        ticket: { ...state.ticket, data: action.response }
      }
    }
    case sc.UPDATE_TICKET_FAILURE: {
      return {
        ...state
      }
    }
    default:
      return state
  }
}
